export default "__VITE_ASSET__DdfvsK1U__"